"use client";
import { jsx as a, jsxs as u } from "react/jsx-runtime";
import { ChevronLeft as x, ChevronRight as f } from "@videoblocks/react-icons";
import { cn as c } from "../../../utils/utils.mjs";
import { getAccessibleFocusStyles as p } from "../../../utils/styles.mjs";
const N = (s, t) => Array.from({ length: t - s }, (e, n) => n + s), b = (s, t, e = 5) => {
  const n = Math.max(1, Math.min(s - Math.floor((e - 3) / 2), t - e + 2)), l = Math.min(t, Math.max(s + Math.floor((e - 2) / 2), e - 1));
  return [
    ...n > 2 ? [1, "…"] : n > 1 ? [1] : [],
    ...N(n, l + 1),
    ...l < t - 1 ? ["…", t] : l < t ? [t] : []
  ];
}, o = "text-sm font-semibold leading-5", i = c(o, "cursor-pointer", p()), g = c(
  o,
  "flex items-center justify-center rounded-capsule px-[7px] bg-neutral-dark-1000 text-neutral-dark-100 pointer-events-none"
), C = ({
  resultsPerPage: s,
  totalResults: t,
  currentPage: e,
  goTo: n,
  className: l
}) => {
  const m = Math.max(1, Math.ceil(t / s)), d = b(e, m);
  return /* @__PURE__ */ a("div", { className: "flex justify-center mt-12 w-full", children: /* @__PURE__ */ u(
    "div",
    {
      className: c(
        "flex items-center justify-center gap-6 px-6 py-4 min-w-[352px] rounded-md bg-neutral-dark-200 text-neutral-dark-1000",
        l
      ),
      children: [
        e !== 1 && /* @__PURE__ */ a("button", { "aria-label": "Previous page", onClick: () => n(e - 1), className: i, children: /* @__PURE__ */ a(x, { className: "w-4 h-4 fill-current" }) }),
        d.map(
          (r, h) => r === "…" ? /* @__PURE__ */ a("span", { className: o, "aria-hidden": "true", children: "…" }, `ellipsis-${h}`) : r === e ? /* @__PURE__ */ a("button", { disabled: !0, "aria-current": "page", className: g, children: r }, r) : /* @__PURE__ */ a("button", { onClick: () => n(r), className: i, children: r }, r)
        ),
        e !== m && /* @__PURE__ */ a("button", { "aria-label": "Next page", onClick: () => n(e + 1), className: i, children: /* @__PURE__ */ a(f, { className: "w-4 h-4 fill-current" }) })
      ]
    }
  ) });
};
export {
  C as Pagination
};
